import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ActionType } from "../../../store/ActionType";
import { Card, CardActions, CardContent, CardHeader, Grid, InputAdornment, } from "@mui/material";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PersonIcon from '@mui/icons-material/Person';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import Input from "../../../ui/Input";
import { useForm } from "react-hook-form";
import SubmitButton from "../../../ui/SubmitButton";
import Container from "@mui/material/Container";
import authService from "../../../service/AuthServicev2";
import Config from "../../../Config";
import { Autocomplete, TextField, Button } from '@mui/material';
import useMessage from '../../../util/useMessage';
import { MessageType } from '../../../util/Enums';
import { BoldIcon } from '../../../menu/muiStyles';
import useGlobal from '../../../util/Global';
import SharedMemoeryservice from '../../../service/MasterServices/SharedMemoeryService';
import useQuery from '../../../util/useQuery';
import Accountservice from '../../../service/Core/AccountService';
import { useAppCookies } from '../../../util/useAppCookies';


const LoginPagev2 = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const { isLoading, g } = useGlobal();
    const { setUser,getUser } = useAppCookies();

    useEffect(() => { }, [isLoading]);

    const [inited, setInited] = useState(false);
    const [loading, setLoading] = useState(false);

    const [tenantList, setTenantList] = useState(null);
    const [selectedTenant, setSelectedTenant] = useState(null);

    const [masterToken, setMasterToken] = useState(null);

    const { register, handleSubmit, formState: { errors } } = useForm();

    const showMessage = useMessage();

    const query = useQuery();


    const autoLogin = useCallback(async () => {

        const uniqueUrl = query.get('uniqueUrl');

        if (uniqueUrl) {

            setLoading(true);
            var result = await SharedMemoeryservice.get({ Key: uniqueUrl });
            if (result.isSuccess) {

                const user = await authService.getbyToken(result.resultObject.masterToken);

                setUser({
                    accessToken: result.resultObject.tenantToken,
                    isMaster: false,
                    loginType: "tenant",
                    tenantName: result.resultObject.tenantName,
                    tenantIcon: result.resultObject.tenantIcon,
                    module: result.resultObject.module,
                    masterToken: result.resultObject.masterToken,
                    userId: user.id
                });


                dispatch({
                    type: ActionType.LOGIN,
                    user: user,
                    token: user.accessToken,
                    loginType: "tenant",
                    tenantUser: user.masterTenant,
                    masterUser: user.masterToken
                });

                setLoading(false);

                history.push(result.resultObject.pageYol);

            }
            console.log(result);
        }


        // Use the tokens as needed in your React app

    }, [query, dispatch, history]);

   const autoLoginwithSession  = useCallback(async (sessionKey) => {
        try {

            setLoading(true);
            setInited(false);

            const {isSuccess, message, tenant} = await Accountservice.loginWithSession(sessionKey);

            if (!isSuccess) {
                showMessage(g(message), MessageType.ERROR);
                return;
            }
            
            setMasterToken(Accountservice.user.masterToken);
            if (!tenantList && tenant.length === 1) {
                setSelectedTenant(tenant[0]);
                await onSelectTenant(tenant[0], Accountservice.user);
            }

            if (!tenantList) {
                setTenantList(tenant);
            }

            setLoading(false);

        } catch (e) {
            if (e.response?.status === 401) {
                showMessage(g('message.invalidUsernameOrPassword'), MessageType.ERROR);
            } else {
                showMessage(g('message.invalidUsernameOrPassword'), MessageType.ERROR);
            }
            setTimeout(() => {
                window.location.href = 'https://sso.securitas.com.tr'; 
            }, 500);
            setLoading(false);
        }
    });

    useEffect(() => {
        const  user = getUser();
        const params = new URLSearchParams(window.location.search);
        const pma = params.get("pma");
        const sessionKey = params.get("sessionKey");
        
        if (sessionKey !== null && sessionKey !== "") 
        {
            autoLoginwithSession(sessionKey);
        }
        
        if (!(user && user.accessToken) && !(pma === "true"  || sessionKey !== null ) && Config.SSOLogin) {
            window.location.href = "https://sso.securitas.com.tr";
        }
        
        autoLogin();
    }, []);


    const onSubmit = async (data) => {
        try {

            setLoading(true);
            setInited(false);
            const { username, password } = data;

            const { isSuccess, message, tenant, isMaster, masteruser } = await Accountservice.login(username, password);

            if (!isSuccess) {
                showMessage(g(message), MessageType.ERROR);
                return;
            }

            if (isMaster) {

                setUser(masteruser);


                dispatch({
                    type: ActionType.MASTER_LOGIN,
                    user: masteruser,
                    loginType: "admin",
                    token: masteruser.accessToken,
                    tenantUser: masteruser.masterTenant,
                    masterUser: masteruser.masterToken
                });

                history.push("/yonetim");
            } else {
                setMasterToken(Accountservice.user.masterToken);

                if (!tenantList && tenant.length === 1) {
                    setSelectedTenant(tenant[0]);
                    await onSelectTenant(tenant[0], Accountservice.user);
                }

                if (!tenantList) {
                    setTenantList(tenant);
                }
            }

            setLoading(false);

        } catch (e) {
            if (e.response?.status === 401) {
                showMessage(g('message.invalidUsernameOrPassword'), MessageType.ERROR);
            } else {
                showMessage(g('message.invalidUsernameOrPassword'), MessageType.ERROR);
                console.log(e);
            }
            setLoading(false);
        }
    }

    const onSelectTenant = async (targetTenant) => {

        setLoading(true);

        const tenant = targetTenant ?? selectedTenant;

        const { isSuccess, message, user, pageurl } = await Accountservice.loginAsTenant(tenant);

        if (!isSuccess) {
            showMessage(g(message), MessageType.ERROR);
            return;
        }

        setUser(user);


        dispatch({
            type: ActionType.LOGIN,
            user: user,
            loginType: "tenant",
            token: user.accessToken,
            tenantUser: user.masterTenant,
            masterUser: user.masterToken
        });

        history.push(pageurl);

        setLoading(false);

    }

    const loginPage = () => {
        return (<Card className="login-card">
            <form onSubmit={handleSubmit(onSubmit)}>
                <CardHeader
                    title={g('title.login')}
                    subheader={g('title.loginSubtitle')}
                />
                <CardContent>
                    <Input
                        label={g('label.username')}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PersonIcon />
                                </InputAdornment>
                            )
                        }}
                        error={errors?.username}
                        {...register("username", {
                            required: g('validation.required'),
                            /*pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: g('validation.email')
                            }*/
                        })}
                    />
                    <Input
                        type="password"
                        label={g('label.password')}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <VpnKeyIcon />
                                </InputAdornment>
                            ),
                        }}
                        error={errors?.password}
                        {...register("password", {
                            required: g('validation.required')
                        })}
                    />

                </CardContent>
                <CardActions>
                    <SubmitButton loading={loading} startIcon={<LockOpenIcon />} fullWidth>
                        {g('button.login')}
                    </SubmitButton>
                </CardActions>
            </form>
        </Card>)
    }

    const handleSelectTenant = (event, newValue) => {
        setSelectedTenant(newValue);
    };

    const teantSelection = () => {
        return (<Card className="login-card">
            <CardHeader
                title={g('title.login')}
                subheader={g('title.loginSubtitle')}
            />
            <CardContent>
                <Autocomplete
                    options={tenantList}
                    getOptionLabel={(option) => option.masterTenant.name}
                    onChange={handleSelectTenant}
                    renderInput={(params) => <TextField {...params} label="Seçiniz" variant="outlined" />}
                />

            </CardContent>
            <CardActions>
                <Button variant="contained" color="primary" onClick={() => onSelectTenant()}>
                    OK
                </Button>
            </CardActions>
        </Card>);
    }

    return (
        <div className="login-panel">
            <Container>
                <Grid container
                    direction="row"
                    justifyContent="center"
                    alignItems="center">
                    <Grid item lg={4}>
                        {tenantList != null ? teantSelection() : loginPage()}
                        <div style={{ textAlign: "center", marginBottom: 10, marginTop: 20 }}>
                            <BoldIcon url={Config.MenuIcon} width={175} height={50} />
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );

};

export default LoginPagev2;
